import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    modal: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modalContent: {
      width: "691px",
      backgroundColor: theme.white50,
      border: `1px solid ${theme.gray200}`,
      borderRadius: "6px",
    },
    searchAndCloseWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(6, 8),
      gap: theme.spacing(5),
      borderBottom: `1px solid ${theme.gray200}`,
    },
    search: {
      height: 0,
      width: "100%",
      padding: 0,
      borderBottom: "none",
    },
    title: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 500,
      color: theme.gray500,
      padding: theme.spacing(8, 8, 6),
    },
    list: {
      maxHeight: "400px",
      overflowY: "auto",
      paddingTop: theme.spacing(8),
    },
    menuItem: {
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.gray800,
    },
    loader: {
      position: "unset",
    },
    marginLeft: {
      marginLeft: theme.spacing(8),
    },
    labelInfo: {
      marginLeft: theme.spacing(8),
      display: "inline-flex",
      alignItems: "center",
    },
  }),
);
